import { render, staticRenderFns } from "./DisconnectConfirmDialog.vue?vue&type=template&id=6bf1548a&"
import script from "./DisconnectConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./DisconnectConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports